import { Box, Typography } from "@mui/material";
import { useEffect } from "react";
import { fetchInsurance } from "slices/cartReducer";
import { useAppDispatch, useAppSelector } from "store/appHooks";

const InsuranceList = ({ onChange, selected }: any) => {
  const { cartReducer } = useAppSelector((state) => state);
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchInsurance());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box sx={{ mt: "20px" }}>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "24px",
          lineHeight: "31px",
          color: "#323232",
          mb: "15px",
        }}
      >
        Insurance Covered *
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: {
            md: "30px",
            lg: "30px",
            xl: "30px",
            sm: "10px",
            xs: "10px",
          },
        }}
      >
        {cartReducer.insurance.map((insu: any) => (
          <Box
            sx={{
              border:
                selected === insu.id
                  ? "1px solid #6E8C20"
                  : "1px solid #E2E2E2",
              padding: "3% 0 2% 3%",
              width: "100%",
              //   height: "128px",
              background: selected === insu.id ? "#E1FFA2" : "",

              borderRadius: "10px",

              display: "flex",
              flexDirection: "column",
              gap: "10px",

              cursor: "pointer",

              boxShadow:
                selected === insu.id
                  ? "0px 3px 6px 0px #25334B1A, 0px 10px 20px 0px #25334B1A"
                  : "",
            }}
            role="button"
            onClick={() => onChange(insu.id)}
          >
            <img
              src={
                selected === insu.id
                  ? "/assets/img/icons/insurance_checked.svg"
                  : "/assets/img/icons/insurance_unchecked.svg"
              }
              alt=""
              width="24"
              height="24"
            />

            <Typography
              sx={{
                color: "#323232",
                fontSize: "15px",
                fontWeight: 500,
                lineHeight: "19px",
              }}
            >
              {insu.name}
            </Typography>

            <Typography
              sx={{
                color: "#323232",
                fontSize: {
                  md: "24px",
                  lg: "24px",
                  xl: "24px",
                  sm: "16px",
                  xs: "16px",
                },
                fontWeight: 600,
                lineHeight: "31px",
              }}
            >
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                currencyDisplay: "narrowSymbol",
              }).format(insu.price)}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default InsuranceList;
